module.exports = __webpack_public_path__ + "dc3d27f4e51e7080afea34fa43020c38.png";